<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center">
        <v-flex xs12 md10 sm11>
          <h3 class="text-center">Home Based Care Programmes</h3>
          <v-card>
            <v-card-title class="py-1">
              <v-text-field label="Search" v-model="filterBy" prepend-icon="search" clearable :disabled="home_based_cares.length < 1"></v-text-field>
              <v-spacer></v-spacer>
              <v-btn href="/home-based-care/create" outlined text @click.stop.prevent="goTo('/home-based-care/create')">
                <v-icon left>mdi-home-plus</v-icon>
                Add new
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-data-table :items="home_based_cares" :headers="headers" dense :search="filterBy">
                <template v-slot:[`item.client.name`]="{ item }">
                  <inertia-link :href="'/home-based-care/' + item.id">{{ item.client.name }}</inertia-link>
                </template>
                <template v-slot:[`item.created_at`]="{ item }">
                  {{ moment(item.created_at).format('lll') }}
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-btn icon small title="Duplicate" color="orange" @click="duplicate(item)">
                    <v-icon>mdi-content-duplicate</v-icon>
                  </v-btn>
                  <v-btn small icon title="Delete" color="red" @click="deleteProg(item)">
                    <v-icon>{{ icons.delete }}</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'

  export default {
    name: 'HomeBasedCare',
    layout,
    props: [
      'home_based_cares'
    ],
    components: {},
    metaInfo () {
      return {
        title: 'Home-Based Care',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        filterBy: '',
        headers: [
          {
            text: 'Name', value: 'client.name'
          },
          {
            text: 'Condition', value: 'condition'
          },
          {
            text: 'Duration Required', value: 'duration_of_care_needed'
          },
          {
            text: 'Date Created', value: 'created_at',
          },
          {
            value: 'actions', align: 'right'
          }
        ]
      }
    },
    methods: {
      duplicate (prog) {
        swal({
          title: 'Duplicate',
          text: 'You will be taken to another page to choose client/patient',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'orange',
          confirmButtonText:'Duplicate',
        },
        function () {
          this.$inertia.post('/home-based-care/' + prog.id + '/duplicate', {
            onFinish: () => {
              swal.close()
            }
          })
        }.bind(this))
      },
      deleteProg (prog) {
        swal({
          title: 'Delete this programme',
          text: '',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'red',
          confirmButtonText:'Delete',
          closeOnConfirm: false,
          showLoaderOnConfirm: true,
        },
        function () {
          this.$inertia.delete('/home-based-care/' + prog.id, {
            onFinish: () => {
              swal.close()
            }
          })
        }.bind(this))
      }
    },
  }
</script>
